import FormHeader from "@/components/FormHeader"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import api from "@/lib/axios"
import { AxiosError } from "axios"
import { Loader2 } from "lucide-react"
import { useState } from "react"
import toast from "react-hot-toast"
import { GoPlus } from "react-icons/go"
import { LuDownload } from "react-icons/lu"
import { useMutation, useQueryClient } from "@tanstack/react-query"

const importDataSekolah = async (newData: FormData) => {
  const response = await api.post("/master/sekolah/import", newData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
  return response.data
}

export default function FormImport({ closeModal }: { closeModal: () => void }) {
  const [file, setFile] = useState<File | null>(null)

  const queryClient = useQueryClient()
  const { mutate, isPending } = useMutation({
    mutationFn: importDataSekolah,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["listSekolah"] })
      closeModal()
      toast.success(data?.message || "Success.")
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred."
      )
    },
  })

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0]
    if (file) setFile(file)
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const formData = new FormData()
    if (file) formData.append("file", file)

    mutate(formData)
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-y-3">
      <FormHeader title="Import Data Skolah" icon={<GoPlus />} />
      <div>
        <Label>Format Import</Label>
        <Button
          type="button"
          className="w-full flex items-center gap-3"
          variant={"outline"}
          onClick={() => {
            window.open("/format/format-import-sekolah.xlsx")
          }}
        >
          <LuDownload /> Unduh Format Import Siswa
        </Button>
      </div>
      <div>
        <Label>File Excel</Label>
        <Input required type="file" onChange={handleFileChange} />
        {file && (
          <p className="text-sm text-muted-foreground">
            Selected file: {file?.name}
          </p>
        )}
      </div>
      <div className="mt-3 flex gap-3">
        <Button
          variant={"outline"}
          type="button"
          onClick={closeModal}
          disabled={isPending}
        >
          Batal
        </Button>
        <Button className="flex items-center gap-3" disabled={isPending}>
          {isPending ? (
            <>
              <Loader2 className="w-4 h-4 mr-1 animate-spin" />
              Processing...
            </>
          ) : (
            "Import"
          )}
        </Button>
      </div>
    </form>
  )
}
